import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { notification, modal } from 'redux/modules/app'
import { persons as personsApi } from 'redux/modules/api/combineDashboard'
import { schemaProfile, schemaPassword, schemaEmail } from 'models/profile'
import configFile from 'config'
import { waitFor } from '@babel/core/lib/gensync-utils/async'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api }) => ({
        profile: get(api, 'dashboard.persons.profile')
      }),
      {
        ...personsApi,
        notification,
        modal,
        push
      }
    )
    class apiPersons extends Component {
      static propTypes = {
        deleteProfilePhoto: PropTypes.func.isRequired,
        editProfilePhoto: PropTypes.func.isRequired,
        changePassword: PropTypes.func.isRequired,
        changeEmail: PropTypes.func.isRequired,
        changeAssessorEmail: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        loadProfile: PropTypes.func.isRequired,
        editProfile: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        loginChange: PropTypes.func.isRequired
      }

      componentDidMount() {
        config.loadProfile && this.handleLoadProfile()
      }

      handleEditProfile = (
        id,
        fields,
        { resetForm, profile, keepModal, isAssessor }
      ) =>
        this.props
          .editProfile(id, schemaProfile(fields, profile), undefined, {
            isAssessor
          })
          .then(() => {
            if (fields.file) {
              return this.props.editProfilePhoto(id, fields.file)
            } else if (fields.helpers && fields.helpers.deletedFile) {
              return this.props.deleteProfilePhoto(id)
            }
            return true
          })
          .then(() => {
            this.handleSuccess(
              'Your profile has been edited',
              'notifications.your_profile_has_been_edited',
              {
                resetForm,
                keepModal
              }
            )
          })
          .catch(this.handleError)

      handleChangeEmail = (id, fields, { resetForm, isAssessor }) => {
        if (isAssessor) {
          return this.handleChangeAssessorEmail(id, fields, { resetForm })
        }

        return this.props
          .changeEmail(id, schemaEmail(fields))
          .then(() => {
            this.handleSuccess(
              'Email with instructions has been sent to your inbox',
              'notifications.email_with_instructions_has_been_sent_to_your_inbox',
              { resetForm }
            )
          })
          .catch(this.handleError)
      }

      handleChangeAssessorEmail = (id, fields, { resetForm }) =>
        this.props
          .changeAssessorEmail(id, schemaEmail(fields))
          .then(() => {
            this.handleSuccess(
              'Email with instructions has been sent to your inbox',
              'notifications.email_with_instructions_has_been_sent_to_your_inbox',
              { resetForm }
            )
          })
          .catch(this.handleError)

      handleLoginChange = ({ personId, code, isConfirm }) => {
        return this.props
          .loginChange(personId, code)
          .then(() => {
            if (isConfirm) {
              this.handleSuccess(
                'Email address has been confirmed',
                'notifications.email_has_been_confirmed',
                { resetForm: null, redirectToLogin: true }
              )
              return
            }
            this.handleSuccess(
              'Your login email has been changed',
              'notifications.your_login_email_has_been_changed',
              { resetForm: null, redirectToLogin: true }
            )
          })
          .catch(err => this.handleError(err, { redirectToLogin: true }))
      }

      handleChangePassword = (id, fields, { resetForm, skipLoadProfile = false }) => {
     this.props
          .changePassword(id, schemaPassword(fields))
          .then(() => {
            this.handleSuccess(
              'Your password has been changed',
              'notifications.your_password_has_been_changed',
              { resetForm, skipLoadProfile }
            )
          })
          .catch(this.handleError)
      }
      handleSuccess = (
        text = 'Success',
        intlKey = 'notifications.success',
        { resetForm, skipLoadProfile, keepModal, redirectToLogin }
      ) => {
        this.props.notification(text, { status: 'success', intlKey })
        !keepModal && this.props.modal(null, null)

        if(!skipLoadProfile){
          this.handleLoadProfile()
        }

        resetForm && resetForm()
        redirectToLogin && this.props.push(`${configFile.publicPath}/`)
      }

      handleError = (err, { redirectToLogin } = {}) => {
        console.debug('error', err.body && err.body.userMessage)
        this.props.notification(
          err.body &&
            (err.body.userMessage || err.body.developerMessage || 'Error'),
          'error'
        )
        redirectToLogin && this.props.push(`${configFile.publicPath}/`)
        throw err
      }

      handleLoadProfile = () =>
        this.props.loadProfile({ isAssessor: config.isAssessor })

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onChangePassword={this.handleChangePassword}
            onEditProfile={this.handleEditProfile}
            onChangeEmail={this.handleChangeEmail}
            onLoginChange={this.handleLoginChange}
          />
        )
      }
    }
    return apiPersons
  }
}

export default decorator
